const BASE = "/lead";

const GET_LEAD = `${BASE}/get-lead`;
const DELETE_LEAD = `${BASE}/delete-lead/{LEAD_ID}`;

export const LEAD_ROUTE = {
  GET_LEAD,
  DELETE_LEAD,
};
